import { useAcl, type SystemRole } from '@/hooks/useAcl';
import { userProfiles, getInitials } from '@/mocks/userProfiles';

export interface CurrentUser {
  role: SystemRole;
  name: string;
  email: string;
  initials: string;
}

/**
 * Resolves the signed-in identity from the active ACL role. Every surface that
 * shows "who am I" reads this, so switching roles updates the sidebar, the top
 * bar and the dashboard greeting together instead of leaving stale mock names.
 */
export function useCurrentUser(): CurrentUser {
  const { role } = useAcl();
  const profile = userProfiles[role];
  const name = profile?.name ?? role;

  return { role, name, email: profile?.email ?? '', initials: getInitials(name) };
}
